module.exports = __webpack_public_path__ + "static/media/sms.fca1a771.svg";